import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import api from "./api";
import {handleResponseStatus, updateIdField} from "./utils";

const initialState = {
    items: [],
    fetchStatus: "idle",// 'idle' | 'loading' | 'success' | 'failed'
    pagination: {},
    error: null,
};

export const fetchAllFormFieldsData = createAsyncThunk('dashboard/fetchAllFormFieldsData', async () => {
    try {
        const response = await api.get(`/submissions-form`);
        return {...response}
    } catch (error) {
        if (error.response) return error.response;
        throw error;
    }
});

const dashboardSlice = createSlice({
    name: "dashboard",
    initialState: initialState,
    extraReducers(builder) {
        builder
            // fetch all banks
            .addCase(fetchAllFormFieldsData.pending, (state) => {
                state.fetchStatus = 'loading';
            })
            .addCase(fetchAllFormFieldsData.fulfilled, (state, action) => {
                const {fetchStatus, error} = handleResponseStatus(action.payload, 'fetchStatus');
                const {data, ...pagination} = action.payload.data;
                state.items = fetchStatus === "success" ? updateIdField(data) : state.items;
                state.fetchStatus = fetchStatus;
                state.pagination = pagination;
                state.error = error;
            })
            .addCase(fetchAllFormFieldsData.rejected, (state, action) => {
                state.fetchStatus = 'failed';
                state.error = action.error.message;
            })
    }
});

export default dashboardSlice.reducer;


